import { useEffect, useState, createContext, useContext } from 'react'
import { apiGet } from '../../Api_Functions'
import { useUser } from '../useUser'

const FrontEndConfigContext = createContext(null)

// Import typedef from another file
/**
 * @typedef {import('../../utilities/objectStructures/globalStructures').FrontEndConfig} FrontEndConfig FrontEndConfig object
 */
export const FrontEndConfigProvider = ({ children }) => {
  /** @type {[FrontEndConfig, React.Dispatch<FrontEndConfig>]} */
  const [config, setConfig] = useState(null)
  const { user } = useUser()

  useEffect(() => {
    if (!user) return

    apiGet('frontEndConfig').then(setConfig).catch(() => {
      setConfig(null)
    })
  }, [user])

  return (
    <FrontEndConfigContext.Provider value={config}>
      {children}
    </FrontEndConfigContext.Provider>
  )
}

export const useFrontEndConfig = () => {
  return [useContext(FrontEndConfigContext)]
}

export default useFrontEndConfig
